import React, { useEffect } from 'react'
import Hero from '../../components/Hero/Hero'
import MarketingServices from '../../components/MarketingServices/MarketingServices'
import AboutSection from '../../components/AboutSection/AboutSection'
import ServicesSection from '../../components/ServicesSection/ServicesSection'
import FeaturedProjects from '../../components/FeaturedProjects/FeaturedProjects'
import Testimonials from '../../components/Testimonials/Testimonials'
import Team from '../../components/Teams/Team'
import FAQ from '../../components/FAQ/FAQ'

export default function Home() {

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  return (
    <div className='BODY'>
      <Hero />
      <MarketingServices />
      <AboutSection />
      <ServicesSection />
      <FeaturedProjects showMore={true} />
      <Testimonials />
      <Team />
      <FAQ />
    </div>
  );
}
